(function () {
    function isAbSubTestPage() {
        return Boolean(document.body && document.body.classList.contains('product-ab-sub-test'));
    }

    function getMappedTitle(title) {
        var normalized = String(title || '').toLowerCase();
        if (normalized.indexOf('1 stk') > -1) return '1 stk';
        if (normalized.indexOf('2 stk') > -1) return '2 stk';
        if (normalized.indexOf('3 stk') > -1) return '3 stk';
        return title || '';
    }

    function getMappedGiftTitle(title) {
        var original = String(title || '').trim();
        var normalized = original.toLowerCase();

        if (normalized.indexOf('hårguide') > -1) return 'Hårvækst-plan (e-bog)';
        if (normalized.indexOf('deep scalp brush') > -1) return 'Deep Scalp Brush';
        if (normalized.indexOf('mikrofiber håndklæde') > -1) return 'Mikrofiber håndklæde';

        return original;
    }

    function injectAntiFlickerCss() {
        if (document.getElementById('ab-planb-anti-flicker')) return;
        var style = document.createElement('style');
        style.id = 'ab-planb-anti-flicker';
        style.textContent =
            'body.product-ab-sub-test .spw-planb{visibility:hidden;}' +
            'body.product-ab-sub-test .spw-planb[data-ab-titles-ready="true"]{visibility:visible;}';
        document.head.appendChild(style);
    }

    function injectPlanbTitle(widget) {
        if (!widget || !widget.parentNode) return;

        if (widget.previousElementSibling && widget.previousElementSibling.classList.contains('spw-planb__ab-title')) {
            return;
        }

        var title = document.createElement('div');
        title.className = 'spw-planb__ab-title';
        title.textContent = 'Vælg antal';

        widget.parentNode.insertBefore(title, widget);
    }

    function applyAbOverrides(widget) {
        var scope = widget.closest('.main-product') || document;
        var toggleControl = widget.querySelector('.spw-planb__sub-toggle');
        var stockStatusBlock = scope.querySelector('.stock-status-block');

        widget.dataset.abTitlesReady = 'false';

        scope.querySelectorAll('.checkbox-cross-sell-block').forEach(function (block) {
            block.style.display = 'none';
        });

        if (toggleControl && stockStatusBlock && toggleControl.parentNode) {
            if (stockStatusBlock.nextElementSibling !== toggleControl) {
                toggleControl.parentNode.insertBefore(stockStatusBlock, toggleControl);
            }
        }

        injectPlanbTitle(widget);

        // Variant titles
        widget.querySelectorAll('.spw-planb__variant .spw-planb__variant-title').forEach(function (titleEl) {
            var mappedTitle = getMappedTitle(titleEl.textContent);
            if (titleEl.textContent !== mappedTitle) titleEl.textContent = mappedTitle;
        });

        // Gift titles
        widget.querySelectorAll('.spw-planb__gift .spw-planb__gift-name').forEach(function (giftTitleEl) {
            var mappedGiftTitle = getMappedGiftTitle(giftTitleEl.textContent);
            if (giftTitleEl.textContent !== mappedGiftTitle) giftTitleEl.textContent = mappedGiftTitle;
        });

        widget.dataset.abTitlesReady = 'true';
    }

    var rafId = null;
    var observer = null;

    function runAbOverrides() {
        if (!isAbSubTestPage()) return;
        document.querySelectorAll('.spw-planb').forEach(applyAbOverrides);
    }

    function scheduleRun() {
        if (!isAbSubTestPage()) return;
        if (rafId) return;
        rafId = window.requestAnimationFrame(function () {
            rafId = null;
            runAbOverrides();
        });
    }

    function init() {
        if (!isAbSubTestPage()) return;
        injectAntiFlickerCss();
        runAbOverrides();

        observer = new MutationObserver(function () {
            scheduleRun();
        });

        if (document.body) {
            observer.observe(document.body, { childList: true, subtree: true, characterData: true });
        }

        document.addEventListener('click', function (e) {
            var btn = e.target && e.target.closest && e.target.closest('.spw-planb__variant');
            if (!btn) return;
            var widget = btn.closest('.spw-planb');
            if (!widget) return;
            widget.dataset.abTitlesReady = 'false';
            scheduleRun();
            setTimeout(function () {
                widget.dataset.abTitlesReady = 'true';
            }, 100);
        }, true);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
